@if (isLoading) {
    <sb-loader class="mt-3"></sb-loader>
} @else {
    @if (outlookUserService.isLoggedIn) {
        <app-form></app-form>
    } @else {
        <app-login-page (loginIn)="loadUserCommunities()"></app-login-page>
    }
}
<simple-notifications></simple-notifications>
